"use client";

import { createInsightsMiddleware } from "instantsearch.js/es/middlewares";
import { useLayoutEffect } from "react";
import { useInstantSearch } from "react-instantsearch";
import aa from "search-insights";

export function AlgoliaInsightsMiddleware() {
  const { addMiddlewares } = useInstantSearch();

  const sentEvents = new Set<string>();

  useLayoutEffect(() => {
    const middleware = createInsightsMiddleware({
      insightsClient: aa,
      onEvent: (event, client) => {
        const { insightsMethod, payload } = event;

        if (!insightsMethod) return;

        const key = JSON.stringify({
          method: insightsMethod,
          payload: payload,
        });

        if (sentEvents.has(key)) return;

        sentEvents.add(key);

        client(insightsMethod, payload as any);
      },
    });

    return addMiddlewares(middleware);
  }, [addMiddlewares]);

  return null;
}
